<template>
  <q-card flat>
    <q-form @submit="changeData">
      <q-card-section class="no-padding">
        <q-banner inline-actions class="bg-blue text-white">
          <span>تغییر قمت گروه کالا </span>
          <span>{{ groupInfo.Group_Name }}</span>
          <template v-slot:action>
            <q-btn icon="close" flat v-close-popup/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="q-gutter-xs">
        <q-select v-model="changeObject.state" filled
                  :options="states"
                  option-value="id"
                  option-label="caption"
                  map-options
                  emit-value
                  hide-bottom-space
                  :rules="[val => !!val || 'انتخاب الزامی است']"
                  label="نوع تغییر قیمتها"
        />
        <q-input dir="ltr" filled v-model="changeObject.listPricePercent" label="درصد افزایش نرخ قیمت لیست"
                 type="number"
                 step="0.1"/>
        <q-input dir="ltr" filled v-model="changeObject.guildPricePercent" label="درصد افزایش نرخ اتحادیه"
                 type="number"
                 step="0.1"/>
        <q-input dir="ltr" filled v-model="changeObject.buyDayPricePercent" label="درصد افزایش خرید روز"
                 type="number"
                 step="0.1"/>
      </q-card-section>
      <q-card-actions class="text-center" align="center">
        <q-btn label="تایید" type="submit" icon="check" color="primary"/>
        <q-btn label="انصراف" type="reset" icon="cancel" color="red" flat class="q-ml-sm" v-close-popup/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "GoodsGroupPrice",
  props: {
    groupInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      changeObject: {
        groupId: this.groupInfo.Group_ID,
        state: undefined,
        listPricePercent: 0,
        guildPricePercent: 0,
        buyDayPricePercent:0
      },
      states: [
        {id: 1, caption: 'افزایش'},
        {id: 2, caption: 'کاهش'}
      ]
    }
  },
  methods: {
    ...mapActions({
      'changePrice': 'Products/changeGoodsGroupPrice'
    }),
    changeData() {
      this.changePrice(this.changeObject).then((res) => {
        if (res.result===1){
          this.$q.notify({
            type:'positive',
            position:'top',
            icon:'check',
            color:'positive',
            message:'قیمت ها تعییر داده شد'
          })
          this.$emit('close-dialog')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>